<template>
<div class="container mb-4 p-sm-3 col-md-8">
  <h1>
    撮影会／イベント／教室 開催後報告
  </h1>
  <p>
    <span class="attention">※</span>必須
  </p>
  <form class="mb-5" action="index.html" method="post">
    <div class="form-group p-3">
      <label for="lecturer-number">イベントタイトル</label>
      <p class="form-control-static">{{ item.event_name }}</p>
    </div>
    <div class="form-group p-3">
      <label for="lecturer-number">掲載終了日</label>
      <p class="form-control-static">{{ item.end_date }}</p>
    </div>
    <div class="form-group p-3">
      <label for="EventReport">参加人数（組数）</label>
      <pre>{{ eventReport.event_report }}</pre>
    </div>

    <p> 内容を確認の上、よろしければ事務局宛にメールを送信します。</p>
    <div class="btn-group" role="group" aria-label="group">
      <router-link :to="inputPath" class="btn btn-outline-info btn-lg">修正する</router-link>
      <a href="/lecturer/list" class="btn btn-primary btn-lg text-white" :class="submitStyle" @click.prevent="submit()">事務局へ報告</a>
    </div>
  </form>
  <p class="text-right mt-5">
    <router-link to="/mypage">マイページへのリンク</router-link>
  </p>
</div>
</template>

<script>
import api from 'api'
import auth from 'auth'
import modal from 'util/modal'
export default {
  data () {
    return {
      item: {},
      isDisabled: false
    }
  },
  created () {
    api.fetchEvent(this, this.$route.query.id)
    .then(item => {
      this.item = item
    }).catch(err => {
      if (err.status === 401) {
        api.onAuthRequired(this)
      } else {
        modal.showErrorModal(this, err)
      }
    })
  },
  methods: {
    submit () {
      this.isDisabled = true
      let report = {
        'event_id': this.item.event_id,
        'report': this.eventReport.event_report
      }
      api.sendEventReport(this, report)
      .then(_ => {
        this.$router.push('/list')
      }).catch(err => {
        if (err.status === 401) {
          modal.showLoginModal(this)
        } else {
          api.sendClientError(this, {
            'type': 'ClientError',
            'lecturer': auth.getLecturerNo(),
            'message': err.message || err.body.message
          })
          modal.showErrorModal(this, err)
        }
        this.isDisabled = false
      })
    }
  },
  computed: {
    eventReport () {
      return this.$store.state.eventReport
    },
    inputPath () {
      return '/report_input?id=' + this.$route.query.id
    },
    submitStyle () {
      return (this.eventReport.event_report && this.item && this.item.event_id) && !this.isDisabled ? '' : 'disabled'
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReportConfirm.vue?0eba5f84